
import Clients from '@/pages/Clients';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function ClientsPage() {
  return (
    <ProtectedRoute requiredRole="staff">
      <Clients />
    </ProtectedRoute>
  );
}
